// extracted by mini-css-extract-plugin
module.exports = {"carousel":"TextImage_carousel__2Hxcj"};